import { privacy, privacyUpload } from './privacy' // 加密
import { intercept, interceptUpload } from './intercept' // 请求拦截

// 获取当前站点
export function get_web(params) {
    const processedParams = privacy(params)
    return intercept('/api/info', processedParams)
}

// 获取站点模块
export function get_module(params) {
    const processedParams = privacy(params)
    return intercept('/api/modules', processedParams)
}

// 获取通知公告
export function get_notices(params) {
    const processedParams = privacy(params)
    return intercept('/api/notices', processedParams)
}

// 获取banner
export function get_banner(params) {
    const processedParams = privacy(params)
    return intercept('/api/banners', processedParams)
}

// 获取限时抢购
export function get_time(params) {
    const processedParams = privacy(params)
    return intercept('/api/activitys', processedParams)
}

// 获取热门商品
export function get_hot(params) {
    const processedParams = privacy(params)
    return intercept('/api/cards', processedParams)
}

// 获取商品分类
export function get_cardType(params) {
    const processedParams = privacy(params)
    return intercept('/api/getCardType', processedParams)
}

// 获取热门搜索商品
export function get_search_hot(params) {
    const processedParams = privacy(params)
    return intercept('/api/search', processedParams)
}

// 获取商品详情
export function get_detail(params) {
    const processedParams = privacy(params)
    return intercept('/api/cardInfo', processedParams)
}

// 获取商品区服
export function get_area(params) {
    const processedParams = privacy(params)
    return intercept('/api/areas', processedParams)
}

// 获取商品sku
export function get_sku(params) {
    const processedParams = privacy(params)
    return intercept('/api/sku', processedParams)
}

// 免验证检测（罗布乐思）
export function check_account(params) {
    const processedParams = privacy(params)
    return intercept('/api/checkAccounts', processedParams)
}

// 罗布乐思授权（校验账密，返回授权码）
export function ver_alt(params) {
    const processedParams = privacy(params)
    return intercept('/api/verAlt', processedParams)
}

// 罗布乐思绑定账密（verify 授权码）
export function bind_alt(params) {
    const processedParams = privacy(params)
    return intercept('/api/bindAlt', processedParams)
}

// 获取已绑定的罗布乐思账密列表
export function manager_alt(params) {
    const processedParams = privacy(params)
    return intercept('/api/managerAlt', processedParams)
}

// 解除绑定罗布乐思账密（id 绑定记录id）
export function sub_alt(params) {
    const processedParams = privacy(params)
    return intercept('/api/subAlt', processedParams)
}

// 拉起支付
export function pull_pay(params) {
    const processedParams = privacy(params)
    return intercept('/api/pays', processedParams)
}

// 拉起支付（使用积分）
export function pull_integral_pay(params) {
    const processedParams = privacy(params)
    return intercept('/api/payIntegrals', processedParams)
}

// 查询订单状态
export function check_pay(params) {
    const processedParams = privacy(params)
    return intercept('/api/checkPay', processedParams)
}

// 手机号登录、注册
export function register(params) {
    console.log('/api/register 传参', params)
    const processedParams = privacy(params)
    return intercept('/api/register', processedParams).then(response => {
        console.log('/api/register 响应', response)
        return response
    })
}

// 忘记密码
export function reset(params) {
    const processedParams = privacy(params)
    return intercept('/api/reset', processedParams)
}

// 发送验证码
export function send(params) {
    const processedParams = privacy(params)
    return intercept('/api/send', processedParams)
}

// 账号登录
export function login(params) {
    const processedParams = privacy(params)
    return intercept('/api/logins', processedParams)
}

// 校验验证码
export function verify(params) {
    const processedParams = privacy(params)
    return intercept('/api/verify', processedParams)
}

// 微信登录
export function weixin_login(params) {
    const processedParams = privacy(params)
    return intercept('/api/token', processedParams)
}

// 获取用户信息
export function user_info(params) {
    const processedParams = privacy(params)
    return intercept('/api/userInfo', processedParams)
}

// 用户是否开通积分
export function is_integral(params) {
    const processedParams = privacy(params)
    return intercept('/api/isIntegral', processedParams)
}

// 用户开通积分o
export function open_integral(params) {
    const processedParams = privacy(params)
    return intercept('/api/integralUsers', processedParams)
}

// 签到
export function sign_on(params) {
    const processedParams = privacy(params)
    return intercept('/api/signOns', processedParams)
}

// 获取新人优惠券
export function get_new_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/isCanGetCoupon', processedParams)
}

// 领取新人优惠券
export function receive_new_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/receiveCoupons', processedParams)
}

// 获取优惠券总数
export function get_coupon_total(params) {
    const processedParams = privacy(params)
    return intercept('/api/couponTotal', processedParams)
}

// 获取可用优惠券数量
export function get_coupon_num(params) {
    const processedParams = privacy(params)
    return intercept('/api/couponNum', processedParams)
}

// 获取可用优惠券
export function get_unused_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/couponUseList', processedParams)
}

// cdk兑换
export function receive_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/receiveCoupones', processedParams)
}

// 获取cdk优惠券
export function cdk_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/cdkCoupon', processedParams)
}

// 修改昵称
export function updateNickName(params, showTip = true) {
    const processedParams = privacy(params)
    return intercept('/api/channelUser', processedParams, showTip)
}

// 获取头像列表
export function getAvatarList(params) {
    const processedParams = privacy(params)
    return intercept('/api/avatar', processedParams)
}

// 系统客服
export function system_service(params) {
    const processedParams = privacy(params)
    return intercept('/api/getChat', processedParams)
}

// 实名认证开关
export function get_authentication(params) {
    const processedParams = privacy(params)
    return intercept('/api/getAuthentication', processedParams)
}

// 实名认证
export function identity_card(params) {
    const processedParams = privacy(params)
    return intercept('/api/identityCard', processedParams)
}

// 获取我的优惠券
export function get_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/couponLists', processedParams)
}

// 获取我的订单
export function get_order(params) {
    const processedParams = privacy(params)
    return intercept('/api/rechargeLists', processedParams)
}

// 获取积分记录
export function get_integral(params) {
    const processedParams = privacy(params)
    return intercept('/api/integralLists', processedParams)
}

// 积分回退
export function integral_refund(params) {
    const processedParams = privacy(params)
    return intercept('/api/integralCancels', processedParams)
}

// 获取投诉原因
export function get_complaints_reason(params) {
    const processedParams = privacy(params)
    return intercept('/api/complaintses', processedParams)
}

// 上传图片
export function upload_img(params) {
    const processedParams = privacyUpload()
    return interceptUpload('/api/upload/img', params, processedParams)
}

// 投诉
export function submit_complaints(params) {
    const processedParams = privacy(params)
    return intercept('/api/submitComplaintses', processedParams)
}

// 获取投诉记录
export function get_complaints(params) {
    const processedParams = privacy(params)
    return intercept('/api/complaintsLists', processedParams)
}

// 获取未读站内信
export function get_unread_message(params) {
    const processedParams = privacy(params)
    return intercept('/api/privateMessages', processedParams)
}

// 已读站内信
export function read_message(params) {
    const processedParams = privacy(params)
    return intercept('/api/setReads', processedParams)
}

// 获取站内信
export function get_message(params) {
    const processedParams = privacy(params)
    return intercept('/api/privateMessageList', processedParams)
}

// 获取用户协议和隐私条款
export function get_terms(params) {
    const processedParams = privacy(params)
    return intercept('/api/yinsi', processedParams)
}

// 获取专题
export function get_topic(params) {
    const processedParams = privacy(params)
    return intercept('/api/topic', processedParams)
}

// 获取专题详情
export function get_topic_detail(params) {
    const processedParams = privacy(params)
    return intercept('/api/topicInfo', processedParams)
}

// 获取领取专题优惠券
export function get_receive_topicCoupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/receiveTopicCoupon', processedParams)
}

// 专题优惠券展示不展示
export function get_topic_coupon(params) {
    const processedParams = privacy(params)
    return intercept('/api/TopicCoupon', processedParams)
}
// 获取下载配置
export function get_downs(params) {
    const processedParams = privacy(params)
    return intercept('/api/downs', processedParams)
}

// 充值余额
export function pull_rechargeBalance(params) {
    const processedParams = privacy(params)
    return intercept('/api/rechargeBalance', processedParams)
}

// 获取充值列表
export function get_balanceList(params) {
    const processedParams = privacy(params)
    return intercept('/api/balanceList', processedParams)
}

// 申请推广
export function promoteApply(params) {
    const processedParams = privacy(params)
    return intercept('/api/promoteApply', processedParams)
}

// 查询是否已申请推广
export function promoteIsApply(params) {
    const processedParams = privacy(params)
    return intercept('/api/promoteIsApply', processedParams)
}

// ==================== 游戏圈 ====================

// 发布帖子
export function publishPost(params) {
    const processedParams = privacy(params)
    return intercept('/api/threadForm', processedParams)
}

// 编辑帖子
export function editPost(params) {
    const processedParams = privacy(params)
    return intercept('/api/threadChange', processedParams)
}
// 查询充值订单状态
export function checkRecharge_pay(params) {
    const processedParams = privacy(params)
    return intercept('/api/checkRechargePay', processedParams)
}

// 获取游戏列表
export function getChannel(params) {
    const processedParams = privacy(params)
    return intercept('/api/channels', processedParams)
}

// 获取频道帖子列表
export function getThreads(params) {
    const processedParams = privacy(params)
    return intercept('/api/threads', processedParams)
}

// 获取我的帖子列表
export function getMyThreads(params) {
    const processedParams = privacy(params)
    return intercept('/api/myThreads', processedParams)
}

// 获取帖子详情
export function getDetailChannel(params) {
    const processedParams = privacy(params)
    return intercept('/api/threadInfo', processedParams)
}

// 获取游戏频道列表
export function getGameChannels(params) {
    const processedParams = privacy(params)
    return intercept('/api/detailChannel', processedParams)
}

// 帖子点赞
export function threadLike(params) {
    const processedParams = privacy(params)
    return intercept('/api/threadLike', processedParams)
}

// 帖子评论
export function userComment(params) {
    const processedParams = privacy(params)
    return intercept('/api/userComment', processedParams)
}

// 获取新评论数量
export function newCommentNum(params) {
    const processedParams = privacy(params)
    return intercept('/api/newCommentNum', processedParams)
}

// 获取新评论列表
export function getNewComment(params) {
    const processedParams = privacy(params)
    return intercept('/api/newComment', processedParams)
}

// 获取最新评论列表（管理端）
export function getNewestComment(params) {
    const processedParams = privacy(params)
    return intercept('/api/newestComment', processedParams)
}

// 获取评论列表
export function getComments(params) {
    const processedParams = privacy(params)
    return intercept('/api/comments', processedParams)
}

// 获取更多二级评论
export function getMoreComments(params) {
    const processedParams = privacy(params)
    return intercept('/api/moreComments', processedParams)
}

// 评论点赞
export function commentLike(params) {
    const processedParams = privacy(params)
    return intercept('/api/commentLike', processedParams)
}

// 评论已读
export function commentRead(params) {
    const processedParams = privacy(params)
    return intercept('/api/commentRead', processedParams)
}

// 屏蔽/变更评论
export function changeComment(params) {
    const processedParams = privacy(params)
    return intercept('/api/changeComment', processedParams)
}

// 激活事件
export function active(params) {
    const processedParams = privacy(params)
    return intercept('/api/active', processedParams)
}

// 广告数据上报
export function jvAd(params) {
    const processedParams = privacy(params)
    return intercept('/api/jvAd', processedParams)
}

